/* ======================================================================
  Purpose: Intercept "Product Feature" add-to-cart and open the Theme cart drawer
  - Targets only the custom section form (inside .highlighted-product OR with data-inkblox-feature-atc)
  - Uses Theme-like AJAX add-to-cart with "sections" so cart-drawer renders correctly
====================================================================== */
(function () {
  function getCartDrawer() {
    return document.querySelector("cart-drawer");
  }

  function isTargetForm(form) {
    if (!form || form.tagName !== "FORM") return false;

    var action = (form.getAttribute("action") || "").trim();
    if (action !== "/cart/add" && action !== window.routes?.cart_add_url) return false;

    // Only our custom section form OR explicitly marked form
    var inHighlighted = !!form.closest(".highlighted-product");
    var hasDataAttr = form.hasAttribute("data-inkblox-feature-atc");

    return inHighlighted || hasDataAttr;
  }

  function buildAjaxConfig(formData) {
    // We mimic fetchConfig('javascript') behavior from the theme
    return {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
      },
      body: formData,
    };
  }

  function handleSubmit(e) {
    var form = e.target;
    if (!isTargetForm(form)) return;

    var cartDrawer = getCartDrawer();
    if (!cartDrawer) {
      // If drawer isn't present in DOM, do nothing (keep default redirect behavior)
      return;
    }

    // IMPORTANT: stop native submit -> prevents redirect
    e.preventDefault();

    try {
      var formData = new FormData(form);

      // Ask Shopify to return the drawer sections in the /cart/add response
      if (typeof cartDrawer.getSectionsToRender === "function") {
        var sectionIds = cartDrawer.getSectionsToRender().map(function (section) {
          return section.id;
        });
        formData.append("sections", sectionIds);
      } else {
        // Fallback section ids (Taste usually uses these)
        formData.append("sections", ["cart-drawer", "cart-icon-bubble"]);
      }

      formData.append("sections_url", window.location.pathname);

      // Optional: preserve focus like theme does
      if (typeof cartDrawer.setActiveElement === "function") {
        cartDrawer.setActiveElement(document.activeElement);
      }

      var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : "/cart/add";

      fetch(addUrl, buildAjaxConfig(formData))
        .then(function (res) {
          return res.json();
        })
        .then(function (response) {
          // If Shopify returns an error object
          if (response && response.status) {
            // Fallback to default submit if needed
            form.submit();
            return;
          }

          // Render drawer with the same payload structure theme expects
          if (typeof cartDrawer.renderContents === "function") {
            cartDrawer.renderContents(response);
          } else if (typeof cartDrawer.open === "function") {
            cartDrawer.open();
          }

          // Safety: remove empty state class if present
          if (cartDrawer.classList.contains("is-empty")) {
            cartDrawer.classList.remove("is-empty");
          }
        })
        .catch(function () {
          // Hard fallback: keep old behavior
          form.submit();
        });
    } catch (err) {
      // Hard fallback: keep old behavior
      form.submit();
    }
  }

  function init() {
    // Use event delegation so it works even if section gets re-rendered
    document.addEventListener("submit", handleSubmit, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
